import { useParams } from 'react-router-dom';

import {
  IUnderwritingSubmissionDetailParams,
  useConvergeNavigation,
} from '../../contexts';
import { useMemo } from 'react';

export interface IUnderwritingSubmissionDetailPageParams {
  submissionUuid: string;
  quoteUuid?: string;
  entityUuid: string;
}

export const useUnderwritingSubmissionDetailPage = () => {
  const convergeNavigate = useConvergeNavigation();

  const params = useParams<keyof IUnderwritingSubmissionDetailPageParams>();

  const navigate = useMemo(() => {
    return {
      page: ({
        submissionUuid = params.submissionUuid,
        ...extraParams
      }: Partial<IUnderwritingSubmissionDetailParams>) => {
        if (!submissionUuid) {
          throw new Error('Submission UUID not found');
        }
        convergeNavigate.underwritingSubmissionDetail({
          submissionUuid,
          ...extraParams,
        });
      },
    };
  }, [convergeNavigate, params]);

  return {
    params: params as IUnderwritingSubmissionDetailPageParams,
    navigate,
  };
};
